<template>
	<div class="modal" :class="{'open': open}">
		<div class="modal__window-area no-scrollbar" ref="modal">
			<transition name="fade">
				<div class="modal__overlay" v-if="open" @click="handleClose"></div>
			</transition>
			<div class="modal__window" @transitionend="handleTransitionEnd">
				<div class="modal__window-head">
					<div class="modal__title" v-if="data?.title"> {{data.title}}</div>
					<button class="modal__close" type="button" @click="handleClose">
						<svg class="modal__close-icon"><use href="#svg-icon-close"></use></svg>
					</button>
				</div>
				<div class="modal__body no-scrollbar" data-scroll-lock-scrollable>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import scrollLock from 'scroll-lock';
import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";

export default {
	mixins: [
		breakpointsMixin
	],

	emits: [
		'close'
	],

	props: {
		data: {
			type: Object,
			default: {}
		},

		openState: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			open: false
		}
	},

	mounted() {
		if (this.openState) this.open = this.openState;
	},

	watch: {
		open(state) {
			if (state) {
				scrollLock.disablePageScroll(this.$refs.modal);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.modal);
				}, 300);
			}
		},

		openState(state) {
			this.open = state;
		}
	},

	methods: {
		handleClose() {
			this.open = false;
		},

		handleTransitionEnd() {
			!this.open ? this.$emit('close') : null;
		}
	},


	beforeUnmount() {
		setTimeout(() => {
			scrollLock.enablePageScroll(this.$refs.modal);
		}, 300);
	}
}

</script>
